import useContactStore from '@/stores/ContactStore';
import { ReplyIcon } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import TooltipComponent from '@/components/common/tooltip/tooltip';

/**
 * ReplyButton component for Instagram message replies.
 * Appears on hover to allow users to reply to a specific message.
 */
export default function ReplyButton({ message, position = 'right' }) {
  const { setSelectedReplyToMessage } = useContactStore(
    useShallow((state) => ({
      setSelectedReplyToMessage: state.setSelectedReplyToMessage,
    }))
  );

  const handleReply = () => {
    setSelectedReplyToMessage(message);
  };

  // For sent messages, use absolute positioning to the left
  if (position === 'left') {
    return (
      <div className='absolute -left-9 top-1/2 -translate-y-1/2'>
        <TooltipComponent content='Reply' delayDuration='100'>
          <Button
            size='xs'
            variant='ghost'
            className='h-7 w-7 p-0 text-muted-foreground hover:text-foreground'
            onClick={handleReply}
          >
            <ReplyIcon className='h-4 w-4' />
          </Button>
        </TooltipComponent>
      </div>
    );
  }

  // For received messages, render inline with self-center alignment
  return (
    <TooltipComponent content='Reply' delayDuration='100'>
      <Button
        size='xs'
        variant='ghost'
        className={cn(
          'h-7 w-7 self-center p-0 text-muted-foreground hover:text-foreground'
        )}
        onClick={handleReply}
      >
        <ReplyIcon className='h-4 w-4' />
      </Button>
    </TooltipComponent>
  );
}
